// ImageWithZoom.jsx
import React, { useState } from 'react';


import Device from '@core/scripts/components/device';
import SourceImage from "../../image/SourceImage.jsx";
import ProductImageZoom from "../ProductImageZoom.jsx";

const FORBIDDEN_RADIUS = 5;

export default function ProductImageWithZoom ({ image, soldOut , texts, imageZoomAllowed}) {
    const [zoomEnabled, setZoomEnabled] = useState(false);

    const onMouseMove = (event) => {
        if (!soldOut && Device.isMouse() && !zoomEnabled && isZoomWithCurrentMousePositionAllowed(event)) {
            setZoomEnabled(true);
        }
    };

    const isZoomWithCurrentMousePositionAllowed = (event) => {
        const pageLoadMousePosition = window.pageLoadMousePosition;
        if (!pageLoadMousePosition) {
            return false;
        }

        const xPositionAllowed =
            event?.clientX >= pageLoadMousePosition.x + FORBIDDEN_RADIUS ||
            event?.clientX <= pageLoadMousePosition.x - FORBIDDEN_RADIUS;
        const yPositionAllowed =
            event?.clientY >= pageLoadMousePosition.y + FORBIDDEN_RADIUS ||
            event?.clientY <= pageLoadMousePosition.y - FORBIDDEN_RADIUS;

        return xPositionAllowed || yPositionAllowed;
    };

    return (
        <div className="product-image__wrapper--full-width">
            <div onMouseMove={onMouseMove} className="product-image--full-width">
                <SourceImage
                    image={image.preview}
                    className={'product-image__image' + (soldOut ? ' is-inactive' : '')}
                />
                {soldOut && <div className="product-image__sold-out-text">{texts.ada_ausverkauft}</div>}
            </div>
            {(zoomEnabled && imageZoomAllowed) && (
                <ProductImageZoom
                    image={image}
                    zoomEnabled={zoomEnabled}
                    onZoomImageLeave={() => setZoomEnabled(false)}
                />
            )}
        </div>
    );
};

